




























































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { storePulangAps } from "@/store/modules/PulangApsStore";
import PulangApsSvc from "@/services/pulangApsService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { getHumanDateTime } from "@/utility/DateUtils";
import moment from "moment";

@Component({
  components: {
    CardModalTtd,
    UnitRuangPicker
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPulangAps extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("pernyataan_aps", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("pernyataan_aps", "edit");
  }

  showForm = false;
  modalTtd = false;
  dialogSaksi2 = false;
  saksi2Nama = "";
  saving = false;
  formValid = false;
  editId: number | null = null;
  menuTglLahir = false;
  menuTglTtd = false;

  form: any = this.getEmptyForm();

  jkOptions = [
    { text: "Laki-laki", value: "L" },
    { text: "Perempuan", value: "P" },
  ];

  bagianPenyakitOptions = ["Anak", "Bedah", "Dalam", "Kritis"];

  mounted() {
    storePulangAps.fetchByRegister(this.register);
  }

  getEmptyForm() {
    return {
      pembuat_nama: "",
      pembuat_jk: null as string | null,
      pembuat_tgl_lahir: null as string | null,
      pembuat_umur: null as number | null,
      pembuat_alamat: "",
      hubungan_pasien: null as string | null,
      hubungan_lainnya: "",
      ruang_rawat: "",
      bagian_penyakit: "",
      alasan: "",
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: moment().format("YYYY-MM-DD"),
    };
  }

  get storePulangApsRef() {
    return storePulangAps;
  }

  get currentItem() {
    return storePulangAps.currentItem;
  }

  get pasienData() {
    return storePasien.identitasPasien;
  }

  formatDate(date) {
    if (!date) return "-";
    const m = moment(date);
    return m.isValid() ? m.format("DD-MM-YYYY") : "-";
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  formatHubungan(item) {
    const map = {
      diri_sendiri: "Pasien Sendiri",
      suami: "Suami",
      istri: "Istri",
      anak: "Anak",
      ayah: "Ayah",
      ibu: "Ibu",
      saudara_kandung: "Saudara Kandung",
      lainnya: item.hubungan_lainnya || "Lainnya",
    };
    return map[item.hubungan_pasien] || item.hubungan_pasien;
  }

  onHubunganChange(val: string) {
    if (val === "diri_sendiri" && this.pasienData) {
      const jk = this.pasienData.jk;
      this.form.pembuat_nama = this.pasienData.nama || "";
      this.form.pembuat_jk = jk === "Laki-laki" ? "L" : jk === "Perempuan" ? "P" : jk || "";
      const m = moment(this.pasienData.tgl_lahir, ["YYYY-MM-DD", "DD-MM-YYYY"], true);
      this.form.pembuat_tgl_lahir = m.isValid() ? m.format("YYYY-MM-DD") : null;
      this.form.pembuat_alamat = this.pasienData.alamat || "";
      this.calcUmur();
    }
  }

  calcUmur() {
    if (this.form.pembuat_tgl_lahir) {
      this.form.pembuat_umur = moment().diff(moment(this.form.pembuat_tgl_lahir), "years");
    }
  }

  tambah() {
    this.form = this.getEmptyForm();
    this.editId = null;
    this.showForm = true;
  }

  edit() {
    if (!this.currentItem) return;
    this.editId = this.currentItem.id;
    this.form = {
      pembuat_nama: this.currentItem.pembuat_nama || "",
      pembuat_jk: this.currentItem.pembuat_jk || null,
      pembuat_tgl_lahir: this.currentItem.pembuat_tgl_lahir || null,
      pembuat_umur: this.currentItem.pembuat_umur || null,
      pembuat_alamat: this.currentItem.pembuat_alamat || "",
      hubungan_pasien: this.currentItem.hubungan_pasien || null,
      hubungan_lainnya: this.currentItem.hubungan_lainnya || "",
      ruang_rawat: this.currentItem.ruang_rawat || "",
      bagian_penyakit: this.currentItem.bagian_penyakit || "",
      alasan: this.currentItem.alasan || "",
      tempat_tanda_tangan: this.currentItem.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: this.currentItem.tgl_tanda_tangan || moment().format("YYYY-MM-DD"),
    };
    this.showForm = true;
  }

  cancelForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
    this.editId = null;
  }

  async simpan() {
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        hubungan_lainnya: this.form.hubungan_pasien === "lainnya"
          ? this.form.hubungan_lainnya
          : null,
      };

      let resp;
      if (this.editId) {
        resp = await PulangApsSvc.update(this.editId, payload);
      } else {
        resp = await PulangApsSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pernyataan Pulang APS berhasil disimpan");
        this.showForm = false;
        this.form = this.getEmptyForm();
        this.editId = null;
        storePulangAps.fetchByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async tandaiPenyatakan() {
    try {
      const resp = await PulangApsSvc.markPenyatakan(this.currentItem.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandai tanda tangan Yang Menyatakan");
        storePulangAps.fetchByRegister(this.register);
      }
    } catch {
      // handled by service
    }
  }

  openTtdSaksi1() {
    this.modalTtd = true;
  }

  async passTtdSaksi1(password: string) {
    try {
      const resp = await PulangApsSvc.signSaksi1(this.currentItem.id, { password });
      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Saksi 1 (Petugas RS)");
        appModule.addMsgTtd("");
        storePulangAps.fetchByRegister(this.register);
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtd = true;
      }
    } catch {
      // handled by service
    }
  }

  async tandaiSaksi2() {
    try {
      const resp = await PulangApsSvc.markSaksi2(this.currentItem.id, {
        saksi2_nama: this.saksi2Nama,
      });
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandai tanda tangan Saksi 2 (Keluarga)");
        this.dialogSaksi2 = false;
        this.saksi2Nama = "";
        storePulangAps.fetchByRegister(this.register);
      }
    } catch {
      // handled by service
    }
  }

  cetakPdf() {
    if (this.currentItem) {
      PulangApsSvc.print(this.currentItem.id);
    }
  }

  async hapus() {
    const q = confirm("Anda yakin akan menghapus pernyataan pulang APS ini?");

    if (q) {
      try {
        const resp = await PulangApsSvc.destroy(this.currentItem.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storePulangAps.fetchByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
